/**
 * Which Windows XP icons have been extracted, and at which sizes.
 *
 * GENERATED by `npm run xp:apply` — do not edit. Add an id to
 * `scripts/xp-icons.json` and re-run instead.
 *
 * XP drew each size separately: the 16px art is not a shrunk 48px, it is its
 * own picture on its own grid. `Icon` uses this table to ask for the size it
 * actually wants, and falls back to the original SVG for anything absent.
 */

export type IconSize = 16 | 24 | 32 | 48;

export const ICON_ASSETS: Readonly<Record<string, readonly IconSize[]>> = {
  'back': [16],
  'calc': [16, 32, 48],
  'cmd': [16, 32, 48],
  'control-panel': [16, 32, 48],
  'display': [16, 32, 48],
  'drive': [16, 32, 48],
  'edit': [16],
  'explorer': [16, 32, 48],
  'favorites': [16],
  'file': [16, 32, 48],
  'folder': [16, 24, 32, 48],
  'folder-open': [16, 32, 48],
  'forward': [16],
  'go': [16],
  'help': [16, 24, 32, 48],
  'history': [16],
  'home': [16],
  'ie': [16, 32, 48],
  'image': [16, 32, 48],
  'lnk': [16, 32],
  'logoff': [16, 32, 48],
  'mail': [16, 32],
  'media': [16, 32, 48],
  'mediaplayer': [16, 32, 48],
  'minesweeper': [16, 32, 48],
  'msg-error': [16, 32, 48],
  'msg-info': [16, 32, 48],
  'msg-question': [16, 32, 48],
  'msg-warning': [16, 32, 48],
  'my-computer': [16, 24, 32, 48],
  'my-documents': [16, 24, 32, 48],
  'my-pictures': [16, 24, 32, 48],
  'notepad': [16, 32, 48],
  'outlook': [16, 32, 48],
  'paint': [16, 32, 48],
  'print': [16, 32, 48],
  'recycle-bin': [16, 32, 48],
  'recycle-bin-full': [16, 32, 48],
  'refresh': [16],
  'search': [16, 24, 32, 48],
  'shutdown': [16, 24, 32, 48],
  'solitaire': [16, 32, 48],
  'stop': [16],
  'taskmgr': [16, 32],
  'txt': [16, 32, 48],
  'up': [16],
  'url': [16, 32, 48],
  'volume': [16, 32, 48],
  'volume-muted': [16, 32, 48],
  'zone-internet': [16, 32],
};

/** Where `xp:apply` writes them. */
export const ICON_PNG_DIR = '/assets/icons/png';
